import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';

class SaleReturn extends React.Component {
   render() {
      return (
         <div className="SaleReturn" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/saleReturn/" activeStyle={{ color: 'red' }} >SaleReturn</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/saleReturn/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/saleReturn/newSaleReturn" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
                  <li>
                     <Link to="/saleReturn/dueBills" activeStyle={{ color: 'red' }} >Due Bills</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

SaleReturn.propTypes = {
   children: PropTypes.object
};

export default SaleReturn;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/SaleReturn.js
 **/